import { MHTTPCL, createHttpGetOptions } from "../../../services/http/http-client";

export const AIChatService = {
  // https://dev.berlin3.com/updatecheck2/detailsai.pl?section=chatbot&action=ask&msg=how
  ask: (msg, moduleName="booking", optoins) => MHTTPCL.get2("/detailsai.pl", {
    section: "chatbot",
    action: "ask",
    module: moduleName,
    msg: msg,
  }, createHttpGetOptions({
    noJsonOutput: true,
    cancelToken: optoins?.cancelToken,
    subdomain: "ai",
  })),
  // https://dev.berlin3.com/updatecheck2/detailsai.pl?section=chatbot&action=history&end=2
  history: (start = 0, end = 0, moduleName="booking") => MHTTPCL.get2("/detailsai.pl", {
    section: "chatbot",
    action: "history",
    module: moduleName,
    end,
    start,
  }, createHttpGetOptions({
    noJsonOutput: true,
    subdomain: "ai",
  })),
}